import React, {useState, useRef} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from "utils/CommonUtil";
import StringUtil from "utils/StringUtil";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import PageLoading from "../../../../components/loading";
import UI from "../../../../components/UI";
import UIUtils from "../../../../utils/UIUtils";
import UISelect from "../../../../components/selectbox/UISelect";
import codeDataStore from "common/codedata/store/CodeDataStore";

function ContentsContainer() {

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [loadFinish,setLoadFinish] = useState(false);

	const [modiSeq ,setModiSeq] = useState('');
	const [tskAnnYyyy ,setTskAnnYyyy] = useState('');
	const [bizCd ,setBizCd] = useState('');
	const [oldBizCd ,setOldBizCd] = useState('');

	const TSK_ANN_CONT = useRef('');
	const [title,setTitle] = useState('');
	const [cont,setCont] = useState('');
	const [bizNm,setBizNm] = useState('');
	const [regDate,setRegDate] = useState('');
	const [regUserNm,setRegUserNm] = useState('');

	const [yearList, setYearList] = React.useState<any[]>([{value : new Date().getFullYear()+'', nm : new Date().getFullYear()+'년'}]);
	const [year,setYear] = useState(new Date().getFullYear()+'');


	//파일정보 선언
	const [fileValue] = useState(new TbComFile());
	const [uploadComp, setUploadComp] = useState(false);
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);

	//파일업로드
	const [uploadId, setUploadId] = React.useState("");
	const [fileId, setFileId] = React.useState("");

	//파일업로드
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

	//파일업로드 완료
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;

		let fileInfos : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		}[] = [];

		let fileInfo : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		};

		

		//파일등록 정보
		arrayNew?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"ADD"
			}
			console.log("ADD = ", item.originalName);
			fileInfos.push(fileInfo);
		})

		//파일등록 정보
		arrayDel?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"DEL"
			}
			console.log("DEL = ", item.originalName);
			fileInfos.push(fileInfo);
			
		})

		setFileInfoList(fileInfos);
		setUploadComp(true);
    }

	const onFileUpload = () => {
		if(uploadId){
			window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}

	async function initCall(){

		let param = {
			"MODI_SEQ": receivedData.vMODI_SEQ,
			"TSK_ANN_YYYY": receivedData.vTSK_ANN_YYYY,
			"BIZ_CD": receivedData.vBIZ_CD
		};

		const response:any = await CommonUtil.execute({
			url:'adm_1301',
			data: param
		})

		const result = response;
		//setCorpInfo(result);

		console.log(result)
		setBizNm(result.BIZ_NM);
		setRegDate(result.REG_DATE);
		setRegUserNm(result.REG_USERNM);
		setTitle(result.TSK_ANN_TITLE);
		setCont(result.TSK_ANN_CONT);
		setTskAnnYyyy(result.TSK_ANN_YYYY);
		setFileId(result.FILE_ID)
		setOldBizCd(result.BIZ_CD);

		if(result.FILE_INFO != null){
            let fileInfo = result.FILE_INFO;
			//파일등록 정보

			const fileDetail = new TbComFileMapngDetail();
			fileDetail.setDwldId(fileInfo.DWLD_ID);
			fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
			fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
			fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
			fileDetail.setStrePath(fileInfo.STRE_PATH);
			fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
			fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
			fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
			fileDetail.setFileSize(fileInfo.FILE_SIZE);
			fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
			fileDetail.setRegistDt(fileInfo.REGIST_DT);

			fileValue.putTbComFileMapngDetailList(fileDetail);

		}

		setLoadFinish(true);
		//setPAY_CALL_CONT(response.PAY_CALL_CONT);
		TSK_ANN_CONT.current = result.TSK_ANN_CONT;
		(document.activeElement as HTMLElement).blur();
		

		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}
	};

	//목록 
	async function onClickList() {
	    let dataToSend = {};
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: './adm1300',
	      state: { data: dataToSend }
	    });

    };   

	//취소 버튼시 상세로 이동
	async function onClickDetail() {
		var vTSK_ANN_YYYY = receivedData.vTSK_ANN_YYYY;
		var vMODI_SEQ = receivedData.vMODI_SEQ;
		var vBIZ_CD = receivedData.vBIZ_CD;

	    let dataToSend = {
			vTSK_ANN_YYYY,
			vMODI_SEQ,
			vBIZ_CD
		};
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: './adm1301',
	      state: { data: dataToSend }
	    });

    }; 

	async function deleteAnn(){
		if(await UIUtils.confirm('삭제하시겠습니까?')){
			let param = {
				"MODI_SEQ": modiSeq,
				"TSK_ANN_YYYY": tskAnnYyyy,
				"BIZ_CD": bizCd
			};

			const response:any = await CommonUtil.execute({
				url:'adm_1301_delete',
				data: param
			}).then((response: any) => {
				UIUtils.alert('삭제되었습니다.').then();
				const result = response;

				// 다른 페이지로 이동하면서 데이터 전달
				history.push({
					pathname: './adm1300',
					state: { data: {} }
				});
        	}).catch((error) => {
            	CommonUtil.showAxiosError(error);
            	return;
        	});

		}
	};

	

	const alertModal = async () => {
		const value = await UIUtils.alert(<>
			필수 입력이 완료되지 않았습니다.<br/>
			다시 확인해 주세요.
		</>);
	}

	async function chkValid(){

		if(title == ''){
			alertModal();
			return false;
		}

		if(cont == ''){
			alertModal();
			return false;
		}
		if(cont == '<p><br></p>'){
			alertModal();
			return false;
		}

		if(year == ''){
			alertModal();
			return false;
		}
		if(bizCd == ''){
			alertModal();
			return false;
		}

		if(TSK_ANN_CONT.current == ''){
			alertModal();
			return false;
		}

		if(TSK_ANN_CONT.current == '<p><br></p>'){
			alertModal();
			return false;
		}

		return true;


	}

	
	async function userFormCheck(){
		if(await chkValid()){
	  
			if(await UIUtils.confirm('저장하시겠습니까?')){
				setUploadComp(true);  //폼 체크 여부 
				onFileUpload();
			}
		}
	}; 

	//사용자 등록 저장
	async function onClickSave(sendParam) {
        const response:any = await CommonUtil.execute({
            url:"adm_1303_update",
			data: sendParam
        })
		.then((response: any) => {
			UIUtils.alert('저장되었습니다.').then(()=>{
            	// @ts-ignore
            	onClickList();
            });
		}).catch((error) => {
	    	CommonUtil.showAxiosError(error);
	    	return;
       	});	  
       	
    }

	React.useEffect(() => {
		if(fileInfoList && uploadComp) {

			let param = {
				TSK_ANN_TITLE:title
				,TSK_ANN_CONT:TSK_ANN_CONT.current
				,TSK_ANN_YYYY:year
				,BIZ_CD:bizCd            //셀렉트 박스에  사업CD
				,OLD_BIZ_CD:oldBizCd     //기존 오리지널 사업CD    
				,FILE_ID:fileId
				,MODI_SEQ:modiSeq
				,FILE_INFO_LIST:fileInfoList
			}
			
			onClickSave(param);
		}
	}, [fileInfoList])

	const handleSelect = (e) => {
		if(e.target.name === 'year'){
			setYear(e.target.value);
		}
	};

	React.useEffect(() => {
		//넘어온 파라미터 바인딩
		if(receivedData !==undefined){
			setTskAnnYyyy(StringUtil.defaultString(receivedData.vTSK_ANN_YYYY));
			setBizCd(StringUtil.defaultString(receivedData.vBIZ_CD));
			setModiSeq(StringUtil.defaultString(receivedData.vMODI_SEQ));
			initCall();
			(document.activeElement as HTMLElement).blur();
			$('#title').focus();
		}
	}, [])//effect

    
	if(!loadFinish)
		return (
			<PageLoading />
		)
	else	

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">기금관리</Link></li>
					<li><Link to="#">과제관리</Link></li>
					<li><Link to="#">과제신청안내관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">과제 신청 안내 수정</h1>
					<div className="fo fo-col2">
						<div className="inner">
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key"  id="title">제목</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} placeholder={'제목을 입력하세요.'} value={title} valueChanged={(value) => setTitle(value)} />
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">사업구분</p>
								<div className="fo-value">
									<div className="sl sl-md w100p">
										<UISelect
											value={bizCd}
											valueChanged={(value) => setBizCd(String(value))}
											codeData={codeDataStore.get("cfms.portalBizCdList")}
											firstName={"sel"}
										/>
									</div>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">과제신청안내년도</p>
								<div className="fo-value">
									<div className="sl sl-md w120">
										<select name="year" id="year" value={year} onChange={(handleSelect)}>
											{yearList.map((year, idx) => (
												<option value={year.value}>{year.nm}</option>
											))}
										</select>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">내용</p>
								<div className="fo-value">
									<div className='w100p'>
										<UI.SunEditor
											value={TSK_ANN_CONT.current}
											valueChanged={(value) => TSK_ANN_CONT.current = value}
											autoFocus={false}
										/>
									</div>
								</div>
							</div>							
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">첨부파일</p>
								<div className="fo-value">
									<div className='w100p'>
										<UI.FileUpload
										    value={fileValue}
                            				onCreationComplete={onCreationComplete}
                            				onUploadComplete={onUploadComplete}
                            				attrs={{
                                				MaxTotalFileCount: "1",
                                				ExtensionAllowOrLimit: "1",
                                				Width:"100%",
                                				ImgPreView: "1",
                                				Views: "thumbs"
                            				}}
                            			/>
									</div>
								</div>
							</div>							

						</div>
					</div>

					<div className="hz-root hz-right hz-gap5 mt10">
						<Button color="pri-o" size="sm" onClick={userFormCheck}>저장</Button>
						<Button color="gray-o" size="sm" onClick={deleteAnn}>삭제</Button>
						<Button color="gray-o" size="sm" onClick={onClickDetail}>취소</Button>
						<Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
					</div>					
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;